// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2BUDm","row":"ProcedureTreatmentSummary_row__23GPc"};